function List({ listItemRefs, width, icon, altIcon, items }) {
    return ( 
        <ul className='w-full lg:pr-12 py-4 flex flex-col justify-center lg:justify-start gap-8'>
            {items.map((text, index) => (
            <li 
                key={index} 
                data-aos="fade-up" 
                ref={(el) => (listItemRefs.current[index] = el)}>
                <div className={`flex ${width < 1280 ? 'flex-col lg:flex-row items-center gap-2' : '' }`}>
                    <span className='lg:mr-4 xl:w-[5%] lg:w-[10%] md:w-[5%] sm:w-[10%] w-[20%]'>
                        <img src={icon} alt={altIcon} />
                    </span>
                    <span className='w-[90%] text-center lg:text-start'>
                        <p className='text-xl mini-screen:text-base'>{text}</p>
                    </span>
                </div>
            </li>
            ))}
        </ul> 
    )
}

export default List;